import styled from 'styled-components/macro';
import tw from 'tailwind.macro';

export const Tag = styled.span`
  border-color: ${(p) => p.theme.colors.primaryColor};
  color: ${(p) => p.theme.colors.text};
  display: inline-block;
  ${tw`text-xs border rounded-full px-2 py-1 mr-2 mb-2`}
`;
